export default "bfee511ca2cae2e4.svg"